<app-drawer-layout
  title="Add budget"
  subtitle="Choose a group, pick the budget type, then set the monthly amount. You can change the type later in budget settings."
>
  <app-add-bucket
    [groupId]="groupId"
    (createdBucket)="drawerService.completeAddBucket($event)"
  />
</app-drawer-layout>
